import styled from 'styled-components';

import { centeredTextMixin, colors, h6DesktopMixin, px } from '../../../../contrib/ui';

export const ScorerDataStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    border-radius: 50%;
    height: ${px(40)};
    margin-right: ${px(13)};
    width: ${px(40)};
  }
  .scorer-name {
    ${centeredTextMixin}
    ${h6DesktopMixin};
    color: ${colors.grey4a};
  }
`;
